import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { Role, rolesQueryKeyRoot } from './listRoles';

export interface GetRoleByIdParams {
  id: string;
}

export interface GetRoleByIdResponse {
  success: boolean;
  roles: Role[];
}

const getRoleById: QueryFunction<
  GetRoleByIdResponse,
  [typeof rolesQueryKeyRoot, string | null, GetRoleByIdParams]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const { id } = queryKey[2];
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  // Fetch all roles with permissions and filter by id
  const response = await authTokenHttp<GetRoleByIdResponse>(
    `/shared/roles?includePermissions=true`,
    {
      method: 'GET',
    },
  );

  if (response.data) {
    const role = response.data.roles.find((r) => r.id === id);
    if (role) {
      return {
        success: true,
        roles: [role],
      };
    }
    throw new Error(`Role with id "${id}" not found`);
  }
  throw new Error('Failed to fetch role');
};

export default getRoleById;

const _mockData: GetRoleByIdResponse = {
  success: true,
  roles: [
    {
      id: 'mock-1',
      name: 'Admin',
      description: 'Administrator role with full access',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
      permissions: ['loan.view_all', 'tenant.manage', 'user.manage'],
    },
  ],
};
